// AUTO-GENERATED — do not edit.
// Source: business/ishvaram/data/domain/astrology/baby_names.yaml (nakshatra_letters).
// Regenerate: uv run python execution/gen_nakshatra_akshara_ts.py
// The classical nakshatra naming-syllable (akshara) reference — the first
// syllable of a person's name is traditionally chosen from the pada of their
// janma Nakshatra, so it encodes the Moon Nakshatra used in Gun Milan.

export interface NakshatraAkshara {
  nakshatra: string;
  /** The four pada naming syllables, in pada order. */
  syllables: string[];
}

export const NAKSHATRA_AKSHARA: ReadonlyArray<NakshatraAkshara> = [
  { nakshatra: "Ashwini", syllables: ["Chu", "Che", "Cho", "La"] },
  { nakshatra: "Bharani", syllables: ["Li", "Lu", "Le", "Lo"] },
  { nakshatra: "Krittika", syllables: ["A", "I", "U", "E"] },
  { nakshatra: "Rohini", syllables: ["O", "Va", "Vi", "Vu"] },
  { nakshatra: "Mrigashira", syllables: ["Ve", "Vo", "Ka", "Ki"] },
  { nakshatra: "Ardra", syllables: ["Ku", "Gha", "Nga", "Chha"] },
  { nakshatra: "Punarvasu", syllables: ["Ke", "Ko", "Ha", "Hi"] },
  { nakshatra: "Pushya", syllables: ["Hu", "He", "Ho", "Da"] },
  { nakshatra: "Ashlesha", syllables: ["Di", "Du", "De", "Do"] },
  { nakshatra: "Magha", syllables: ["Ma", "Mi", "Mu", "Me"] },
  { nakshatra: "Purva Phalguni", syllables: ["Mo", "Ta", "Ti", "Tu"] },
  { nakshatra: "Uttara Phalguni", syllables: ["Te", "To", "Pa", "Pi"] },
  { nakshatra: "Hasta", syllables: ["Pu", "Sha", "Na", "Tha"] },
  { nakshatra: "Chitra", syllables: ["Pe", "Po", "Ra", "Ri"] },
  { nakshatra: "Swati", syllables: ["Ru", "Re", "Ro", "Taa"] },
  { nakshatra: "Vishakha", syllables: ["Ti", "Tu", "Te", "To"] },
  { nakshatra: "Anuradha", syllables: ["Na", "Ni", "Nu", "Ne"] },
  { nakshatra: "Jyeshtha", syllables: ["No", "Ya", "Yi", "Yu"] },
  { nakshatra: "Mula", syllables: ["Ye", "Yo", "Bha", "Bhi"] },
  { nakshatra: "Purva Ashadha", syllables: ["Bhu", "Dha", "Pha", "Dha"] },
  { nakshatra: "Uttara Ashadha", syllables: ["Bhe", "Bho", "Ja", "Ji"] },
  { nakshatra: "Shravana", syllables: ["Ju", "Je", "Jo", "Gha"] },
  { nakshatra: "Dhanishta", syllables: ["Ga", "Gi", "Gu", "Ge"] },
  { nakshatra: "Shatabhisha", syllables: ["Go", "Sa", "Si", "Su"] },
  { nakshatra: "Purva Bhadrapada", syllables: ["Se", "So", "Da", "Di"] },
  { nakshatra: "Uttara Bhadrapada", syllables: ["Du", "Tha", "Jha", "Da"] },
  { nakshatra: "Revati", syllables: ["De", "Do", "Cha", "Chi"] },
];
